import React from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';

const ResultAnswer = ({ title, isPercentage, count, total }) => {
    const receivedNaN = !Number.isFinite(count) || !Number.isFinite(total) || (count === 0 && total === 0);
    const progressPercent = (receivedNaN ? 0 : Math.round((count / total) * 10000) / 100) + '%';

    return (
        <p className={'poll-result-answer-progress'}>
            <span className="poll-result-answer-progress-bar" style={{ width: progressPercent }}></span>
            <span className="poll-result-answer-progress-value">{title}</span>
            <span className="poll-result-answer-progress-percent">{receivedNaN ? "" : isPercentage ? progressPercent : count}</span>
        </p>
    )
};



export default ({ poll, headerHidden }) => {
    const { getProperty } = useLocaleContext();

    const total = poll.answer.reduce((sum, answer) => sum + answer.count, 0);

    return (
        <article className={'poll'}>
            {poll.imageUrl && (
                <div className="poll-image-container">
                    <img
                        src={poll.imageUrl}
                        className="poll-image"
                        alt={getProperty(poll, "text")}
                        title={getProperty(poll, "text")}
                    />
                </div>
            )}
            {!headerHidden && <p className={"poll-text"}>{getProperty(poll, 'text')}</p>}
            {poll.answer.map((answer) => (
                <ResultAnswer
                    key={answer.id}
                    title={getProperty(answer, 'text')}
                    isPercentage={poll.percentage}
                    count={answer.count}
                    total={total}
                />
            ))}
        </article>
    );
};
